import type { MatchPhase } from '../api/types';

export const PHASE_LABEL: Record<MatchPhase, string> = {
  GROUP: 'Faza grupowa',
  ROUND_OF_32: '1/16 finału',
  ROUND_OF_16: '1/8 finału',
  QUARTER_FINAL: 'Ćwierćfinały',
  SEMI_FINAL: 'Półfinały',
  THIRD_PLACE: 'Mecz o 3. miejsce',
  FINAL: 'Finał',
};

export const PHASE_SHORT: Record<MatchPhase, string> = {
  GROUP: 'Grupa',
  ROUND_OF_32: '1/16',
  ROUND_OF_16: '1/8',
  QUARTER_FINAL: '1/4',
  SEMI_FINAL: '1/2',
  THIRD_PLACE: '3. miejsce',
  FINAL: 'Finał',
};

export function phaseLabel(phase: MatchPhase, group: string | null): string {
  if (phase === 'GROUP' && group) return `Grupa ${group}`;
  return PHASE_SHORT[phase];
}
